exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".calendar-control .calendar-input{width:120px}.calendar-control .calendar-cell{width:40px}", ""]);

// exports
